import { render, staticRenderFns } from "./TrafficSourceList.vue?vue&type=template&id=bb25fbcc&scoped=true"
import script from "./TrafficSourceList.vue?vue&type=script&lang=js"
export * from "./TrafficSourceList.vue?vue&type=script&lang=js"
import style0 from "./TrafficSourceList.vue?vue&type=style&index=0&id=bb25fbcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb25fbcc",
  null
  
)

export default component.exports